import {
  TrendingUp, Coins, Target, PiggyBank, Landmark, Wallet,
  Home, Building2, Repeat, ShieldCheck, HeartPulse, Receipt, Palmtree,
  LifeBuoy, GraduationCap, Percent,
} from "lucide-react";

// Registry powering the portal tiles and routing metadata.
export const TOOLS = [
  { id: "retirement", path: "/retirement", title: "Retirement & SWP", tagline: "Plan a corpus that outlasts you", category: "Plan", icon: Palmtree, accent: "#2D6A4F", flagship: true },
  { id: "emergency-fund", path: "/emergency-fund", title: "Emergency Fund", tagline: "How much to keep aside & where", category: "Plan", icon: LifeBuoy, accent: "#2A6F7F" },

  { id: "sip", path: "/sip", title: "SIP Calculator", tagline: "Grow wealth with monthly investing", category: "Invest", icon: TrendingUp, accent: "#2D6A4F" },
  { id: "lumpsum", path: "/lumpsum", title: "Lumpsum Calculator", tagline: "One-time investment growth", category: "Invest", icon: Coins, accent: "#D99B26" },
  { id: "goal", path: "/goal", title: "Goal Planner", tagline: "How much to invest for a target", category: "Invest", icon: Target, accent: "#D96B43", ai: true },
  { id: "ppf", path: "/ppf", title: "PPF Calculator", tagline: "Tax-free 15-year compounding", category: "Invest", icon: PiggyBank, accent: "#2A6F7F" },
  { id: "nps", path: "/nps", title: "NPS Calculator", tagline: "Pension corpus & monthly payout", category: "Invest", icon: Landmark, accent: "#2D6A4F" },
  { id: "fd", path: "/fd", title: "FD Calculator", tagline: "Cumulative & payout deposits", category: "Invest", icon: Wallet, accent: "#D99B26", export: true },
  { id: "education", path: "/education", title: "Education Planner", tagline: "Fund your child's degree", category: "Invest", icon: GraduationCap, accent: "#D96B43" },

  { id: "home-loan", path: "/home-loan", title: "Home Loan", tagline: "EMI, prepayment & tax benefit", category: "Borrow", icon: Home, accent: "#D96B43", export: true },

  { id: "rental-yield", path: "/rental-yield", title: "Rental Yield", tagline: "Gross & net yield by city", category: "Real Estate", icon: Building2, accent: "#2A6F7F" },
  { id: "buy-vs-rent", path: "/buy-vs-rent", title: "Buy vs Rent", tagline: "Which builds more wealth?", category: "Real Estate", icon: Repeat, accent: "#2D6A4F", ai: true },

  { id: "term-insurance", path: "/term-insurance", title: "Term Insurance", tagline: "Right life cover for your family", category: "Protect", icon: ShieldCheck, accent: "#2D6A4F" },
  { id: "health-insurance", path: "/health-insurance", title: "Health Insurance", tagline: "Recommended medical cover", category: "Protect", icon: HeartPulse, accent: "#D96B43" },

  { id: "income-tax", path: "/income-tax", title: "Income Tax", tagline: "Old vs New regime FY 2025-26", category: "Tax", icon: Receipt, accent: "#D99B26", ai: true, export: true },
  { id: "capital-gains", path: "/capital-gains", title: "Capital Gains Tax", tagline: "Equity & property LTCG/STCG", category: "Tax", icon: Percent, accent: "#D96B43" },
];

export const CATEGORIES = ["Plan", "Invest", "Borrow", "Real Estate", "Protect", "Tax"];

// Indian city rental-yield benchmarks (approx typical gross yield %).
export const CITY_BENCHMARKS = [
  { city: "Mumbai", tier: "Tier 1", yield: 3.0 },
  { city: "Delhi NCR", tier: "Tier 1", yield: 2.8 },
  { city: "Bengaluru", tier: "Tier 1", yield: 3.5 },
  { city: "Hyderabad", tier: "Tier 1", yield: 3.6 },
  { city: "Chennai", tier: "Tier 1", yield: 3.3 },
  { city: "Pune", tier: "Tier 2", yield: 3.8 },
  { city: "Ahmedabad", tier: "Tier 2", yield: 3.9 },
  { city: "Jaipur", tier: "Tier 2", yield: 4.0 },
  { city: "Kochi", tier: "Tier 2", yield: 4.2 },
  { city: "Indore", tier: "Tier 3", yield: 4.5 },
  { city: "Coimbatore", tier: "Tier 3", yield: 4.4 },
];
